import type { FilterOptions } from '../data/types'
import type { FilterState } from '../data/filterState'
import { DEFAULT_FILTERS } from '../data/filterState'
import { FilterPanel, SeriesSelect } from './FilterPanel'
import { SponsorAds } from './SponsorAds'
import styles from './FilterPanel.module.css'

/** Always-visible desktop filter rail, Desktop.dc.html/DesktopCards.dc.html's <aside>: Filters
 *  card (Registration/Racing type checkboxes + Series select) plus the sponsor slot (the 4 real
 *  Google ads, SponsorAds.tsx) below it. */
export function DesktopFilterRail({ filters, selected, onChange }: { filters: FilterOptions; selected: FilterState; onChange: (next: FilterState) => void }) {
  return (
    <aside aria-label="Filters" className={styles.rail}>
      <div className={styles.railCard}>
        <div className={styles.railHeader}>
          <h2 className={styles.railTitle}>Filters</h2>
          <button type="button" className={styles.resetButton} onClick={() => onChange({ ...DEFAULT_FILTERS, search: selected.search, sort: selected.sort })}>
            Reset
          </button>
        </div>
        <FilterPanel filters={filters} selected={selected} onChange={onChange} />
        <SeriesSelect filters={filters} selected={selected} onChange={onChange} />
      </div>
      <SponsorAds />
    </aside>
  )
}
